import React from "react";
import { useFormik } from "formik";
import { useNavigate } from "react-router-dom";

import usePutApi from "../../hooks/use-put-api";
import { showErrorToast } from "src/utils/toast";
import { resetPasswordSchema } from "../../utils/validation-schema";

const ResetPasswordForm: React.FC = () => {
  const navigate = useNavigate();
  const { putData } = usePutApi<any, any>("auth/change-password");

  const { values, touched, errors, handleChange, handleSubmit, handleBlur } = useFormik({
    initialValues: {
      old_password: "",
      new_password: "",
      confirm_password: "",
    },
    onSubmit: (formValues) => {
      putData(formValues)
        .then((res: any) => {
          const transactionPassword = res?.data?.data?.transactionPassword;
          if (transactionPassword) {
            navigate("/password-success", { state: { transactionPassword } });
          }
        })
        .catch((err: any) => {
          const message =
            err?.data?.status_message ||
            err?.status_message ||
            err?.data?.message ||
            "Something went wrong";
          showErrorToast(message);
        });
    },
    validationSchema: resetPasswordSchema,
  });

  return (
    <form className="change-form p-2" method="post" onSubmit={handleSubmit}>
      <div className="form-group">
        <label className="user-email-text" htmlFor="resetOldPassword">Old Password</label>
        <input
          id="resetOldPassword"
          type="password"
          name="old_password"
          className={`form-control ${touched.old_password && errors.old_password ? "is-invalid" : ""}`}
          value={values.old_password}
          onChange={handleChange}
          onBlur={handleBlur}
        />
        {touched.old_password && errors.old_password && (
          <span className="error">{errors.old_password}</span>
        )}
      </div>

      <div className="form-group">
        <label className="user-email-text" htmlFor="resetNewPassword">New Password</label>
        <input
          id="resetNewPassword"
          type="password"
          name="new_password"
          className={`form-control ${touched.new_password && errors.new_password ? "is-invalid" : ""}`}
          value={values.new_password}
          onChange={handleChange}
          onBlur={handleBlur}
        />
        {touched.new_password && errors.new_password && (
          <span className="error">{errors.new_password}</span>
        )}
      </div>

      <div className="form-group">
        <label className="user-email-text" htmlFor="resetConfirmPassword">Confirm Password</label>
        <input
          id="resetConfirmPassword"
          type="password"
          name="confirm_password"
          className={`form-control ${touched.confirm_password && errors.confirm_password ? "is-invalid" : ""}`}
          value={values.confirm_password}
          onChange={handleChange}
          onBlur={handleBlur}
        />
        {touched.confirm_password && errors.confirm_password && (
          <span className="error">{errors.confirm_password}</span>
        )}
      </div>

      <div className="form-group mb-0">
        <button type="submit" className="btn btn-submit btn-login">
          Change Password
        </button>
      </div>
    </form>
  );
};

export default ResetPasswordForm;
